<li class="trigger" (click)="showPopup($event)">
  <span
    class="plus-sign"
    inlineSVG="/assets/icons/add-sec-event-plus.svg"
  ></span>
  <span class="text">Create a New Marker</span>
</li>
<pop-over #popup [my]="'top left'" [at]="'bottom right'">
  <div class="background-overlay" (click)="hidePopup()"></div>
  <div class="popover-container">
    <div
      class="close-popover"
      (click)="hidePopup()"
      inlineSVG="/assets/icons/close-popup-icon.svg"
    ></div>
    <div
      class="popup-screen"
      [ngClass]="{ 'screen-hidden': chooseMarkerTypeScreenShown === false }"
    >
      <div class="new-marker-title">Create a New Marker</div>
      <div class="instructions">
        Choose the type of marker you want to create.
      </div>

      <div class="buttons-container">
        <div
          class="scte-button button"
          (click)="
            chooseMarkerTypeScreenShown = false; newSCTEMarkerScreenShown = true
          "
        >
          <div
            class="marker-icon"
            inlineSVG="/assets/icons/marker-popup-icon.svg"
          ></div>
          <div class="scte-text">SCTE35 Marker</div>
        </div>
        <div
          class="button"
          (click)="
            chooseMarkerTypeScreenShown = false; newDTMFMarkerScreenShown = true
          "
        >
          <div
            class="marker-icon"
            inlineSVG="/assets/icons/marker-popup-icon.svg"
          ></div>
          <div class="dtmf-text">DTMF</div>
        </div>
      </div>
    </div>
    <div
      class="popup-screen"
      [ngClass]="{ 'screen-hidden': newSCTEMarkerScreenShown === false }"
    >
      <div class="new-scte-title">Create a new SCTE35 marker</div>
      <form [formGroup]="checkoutForm" (ngSubmit)="onSubmitSCTE()">
        <label class="scte-label">Marker Name*</label>
        <br />
        <input
          class="large-input input-bottom-margin"
          [ngClass]="{ 'required-input-border': markerNameInputIsRequired }"
          type="text"
          placeholder="MarkerName1234"
          formControlName="markerName"
        />
        <br />
        <label class="scte-label">Duration</label>
        <br />
        <input
          class="large-input"
          type="text"
          placeholder="sec"
          formControlName="duration"
        />
        <br />
        <input
          class="create-button create-scte-button"
          type="submit"
          value="Create"
        />
      </form>
    </div>
    <div
      class="popup-screen"
      [ngClass]="{ 'screen-hidden': newDTMFMarkerScreenShown === false }"
    >
      <div class="new-dtmf-title">Create a new DTMF marker</div>
      <form [formGroup]="checkoutForm" (ngSubmit)="onSubmitDTMF()">
        <label class="scte-label">Marker Name*</label>
        <br />
        <input
          class="large-input input-bottom-margin"
          [ngClass]="{ 'required-input-border': markerNameInputIsRequired }"
          type="text"
          placeholder="MarkerName1234"
          formControlName="markerName"
        />
        <br />
        <div class="form-row input-bottom-margin">
          <div class="input-right-margin">
            <label class="scte-label">Out code</label>
            <br />
            <input
              class="small-input"
              type="text"
              placeholder="Code123456"
              formControlName="outCode"
            />
          </div>
          <div>
            <label class="scte-label">In code</label>
            <br />
            <input
              class="small-input"
              type="text"
              placeholder="Code123456"
              formControlName="inCode"
            />
          </div>
        </div>
        <label class="scte-label">Duration</label>
        <br />
        <input
          class="large-input input-bottom-margin"
          type="text"
          placeholder="sec"
          formControlName="duration"
        />
        <div class="form-row input-bottom-margin">
          <div class="input-right-margin">
            <label class="scte-label">Volume</label>
            <br />
            <input
              class="small-input"
              type="text"
              placeholder="%"
              formControlName="volume"
            />
          </div>
          <div>
            <label class="small-input" class="scte-label">Language</label>
            <br />
            <input
              class="small-input"
              type="text"
              placeholder="ENG"
              formControlName="language"
            />
          </div>
        </div>
        <div class="form-row">
          <div class="input-right-margin">
            <label class="scte-label">Signal Duration*</label>
            <br />
            <input
              class="small-input"
              [ngClass]="{
                'required-input-border': signalDurationInputIsRequired
              }"
              type="text"
              placeholder="Milliseconds"
              formControlName="signalDuration"
            />
          </div>
          <div>
            <label class="scte-label">Signal Delta</label>
            <br />
            <input
              class="small-input"
              type="text"
              placeholder="Milliseconds"
              formControlName="signalDelta"
            />
          </div>
        </div>
        <input
          class="create-button create-dtmf-button"
          type="submit"
          value="Create"
        />
      </form>
    </div>
  </div>
</pop-over>
